import { Typography } from '@mui/material';

const GettingStarted = () => <Typography variant="h5">Getting Started</Typography>;

export default GettingStarted;
